module.exports = __webpack_public_path__ + "static/media/10.523b2166.JPG";